(function () {
    // ✅ prevent double-init (inline + bundled, archive + taxonomy include, etc.)
    if (window.__LUCDEN_NEWS_INF_INIT__) return;
    window.__LUCDEN_NEWS_INF_INIT__ = true;

    const revealObserver = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add("inf-fade--in");
                obs.unobserve(e.target); // animate once
            });
        },
        { root: null, threshold: 0.15 }
    );

    const cfg = window.LUCDEN_NEWS_INF;
    if (!cfg) return;

    const grid = document.getElementById("news-grid");
    const sentinel = document.getElementById("news-infinite-sentinel");
    const loader = document.getElementById("news-infinite-loader");
    if (!grid || !sentinel) return;

    let page = Number(cfg.page || 1);
    let maxPages = Number(cfg.maxPages || 1);
    let loading = false;

    // ✅ prevents fetching same page twice
    const requestedPages = new Set([page]);

    function showLoader(on) {
        if (!loader) return;
        loader.hidden = !on;
    }

    async function loadMore(reason) {
        if (loading) return;
        if (page >= maxPages) return;

        const nextPage = page + 1;

        // ✅ hard lock per page
        if (requestedPages.has(nextPage)) return;
        requestedPages.add(nextPage);

        loading = true;
        showLoader(true);

        try {
            const fd = new FormData();
            fd.append("action", "lucden_news_inf");
            fd.append("nonce", cfg.nonce);
            fd.append("page", String(nextPage));
            fd.append("perPage", String(cfg.perPage || 9));
            fd.append("term", cfg.term || "");

            const res = await fetch(cfg.ajaxUrl, { method: "POST", body: fd });
            const json = await res.json();

            if (json?.success && json?.data?.html) {
                const temp = document.createElement("div");
                temp.innerHTML = json.data.html;

                const newItems = Array.from(temp.children);

                newItems.forEach((el) => {
                    const pid = el.getAttribute("data-post-id");
                    if (pid && document.querySelector('[data-post-id="' + pid + '"]')) {
                        return; // ✅ already on page, skip
                    }

                    const target = el.querySelector(".px-blog-item") || el;

                    target.classList.add("inf-fade"); // start hidden
                    grid.appendChild(el);

                    // reveal only when it comes into viewport
                    revealObserver.observe(target);
                    if (window.LUCDEN_initVideoThumbs) {
                        window.LUCDEN_initVideoThumbs(el);
                    }
                });

                page = nextPage;
                maxPages = Number(json.data.maxPages || maxPages);

                if (page >= maxPages) {
                    observer.disconnect();
                    sentinel.remove();
                    showLoader(false);
                    return;
                }
            }
        } catch (e) {
            console.log("[INF] error", e);
            // if request failed, allow retry for that page
            requestedPages.delete(nextPage);
        } finally {
            loading = false;
            showLoader(false);
        }
    }

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries.some((e) => e.isIntersecting)) loadMore("intersection");
        },
        { root: null, rootMargin: "600px 0px", threshold: 0 }
    );

    if (maxPages > 1) {
        observer.observe(sentinel);
    }
})();